 document.addEventListener("DOMContentLoaded",()=>{
          setTimeout(() => {
             let wc =window.vtlsLiquidData.shopInfo.moneyWithCurrencyFormat
            if(wc.indexOf('amount_no_decimals_with_comma_separator')>=0){
              window.vtlsLiquidData.shopInfo.moneyWithCurrencyFormat.replace('{{amount_no_decimals_with_comma_separator}}', 'price')
            }else if(wc.indexOf('amount_with_comma_separator')>=0){
             wc= window.vtlsLiquidData.shopInfo.moneyWithCurrencyFormat.replace('{{amount_with_comma_separator}}', 'price')
            }else{
              wc = window.vtlsLiquidData.shopInfo.moneyWithCurrencyFormat.replace('{{amount}}', 'price')
            }
          
            const pcf = (el) => {
              document.querySelectorAll(el).forEach(e => {
                const price = e.innerText.replace(/[^0-9.,]/g, '')
               e.innerText = wc.replace("price", price)
              })
            }
            pcf('#__pf [data-product-type="price"]')
            pcf('#__pf  [data-product-type="compare_at_price"]')
             window.onload=()=>{
               // pcf('#__pf  .money')
              
            }
            const hiddenInput = document.querySelector('[name="id"]');
            let previousValue = hiddenInput.value;
            const observer = new MutationObserver((mutations) => {
            // 2: iterate over MutationRecord array
            mutations.forEach(mutation => {
            // 3.1: check if the mutation type and the attribute name match
            // 3.2: check if value changed
            if (
            mutation.type === 'attributes'
            && mutation.attributeName === 'value'
            && hiddenInput.value !== previousValue
            ) {
            previousValue = hiddenInput.value;
            // 3.4: trigger change event
            hiddenInput.dispatchEvent(new Event('change'));
            }
            });
            });
            
            // 4: observe changes on hiddenInput
            observer.observe(hiddenInput, { attributes: true });
            document.querySelector('[name="id"]').onchange=(e)=>{
              setTimeout(()=>{
                 pcf('#__pf  [data-product-type="price"]')
                 pcf('#__pf [data-product-type="compare_at_price"]')
                 // pcf('#__pf .money')
              },1)
            }

            
          }, 1000)
        })